import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { CheckboxModule } from 'primeng/checkbox';
import { CustomerListComponent } from './customer-list/customer-list.component';
import { BillingReportService } from '@admin/billing/billing-report/shared/services/billing-report.service';
import { BillingReportLookupResolveService } from '@admin/billing/billing-report/shared/services/billing-report-lookup-resolve.service';
import { BillingReportRoutingModule } from './billing-report-routing.module';
import { DatePicker } from 'primeng/datepicker';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    CheckboxModule,
    BillingReportRoutingModule,
    DatePicker,
  ],
  providers: [BillingReportService, BillingReportLookupResolveService],
  declarations: [CustomerListComponent],
})
export class BillingReportModule {}
